import PropTypes from "prop-types";

// Custom components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

export default function MatrixColumn(props) {
	const {
		index = 0,
		item = null,
		errors = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					data: [
						{
							type: "Duration",
							min: 0,
							max: 744,
							decimals: 2,
							decimalsEditable: true,
							dashed: fromDisabled,
						},
					],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || "Duration",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "75px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					readOnly,
					data: [
						{
							type: "Duration",
							min: 0,
							max: 744,
							decimals: 2,
							decimalsEditable: true,
							dashed: toDisabled,
						},
					],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || "Duration",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "75px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
				}}
			/>
		</Stack>
	);
}
MatrixColumn.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	errors: PropTypes.array,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
